const defaultLabel = {
  name: 'No Label',
  count: 0,
  color: '#bebebe',
};

export default defaultLabel;
